import React, {useState, useCallback} from 'react'
import * as  styles from './LocationTab.module.scss'
// import { MapPin } from 'react-feather';
import { Icon } from '@iconify/react';

const LocationTab = ({ location }) => {
    const [showInfo, setShowInfo] =  useState(false)

    const highlightMapFrmLocation = useCallback((e, selector=null, classToAdd='on') => {
        let stateID = selector ||  e.target.id.substring(0, 2) || 'none'
        let marker = document.getElementById('usmapFooter').querySelector(`#${stateID}`)
        if(marker){
            marker.classList.add(`${classToAdd}`)
        }
    },[])
    const removeMapHighlights = useCallback((e, classToRemove='on') => {
        let markers = document.getElementById('usmapFooter').querySelectorAll(`.officeMark`)
        if(markers){
            markers.forEach((mark) => { 
                mark.classList.remove(`${classToRemove}`)
            })
        }
    },[])
    const closeLocation = useCallback((e) => {
        if(e.target.matches(`#${location.ContainerID}_btn`) || !e.target.closest(`#${location.ContainerID}-content`)){
            removeMapHighlights(e='', 'open')
            setShowInfo(false)
            document.removeEventListener("click", closeLocation);
        }
      
       }, [location.ContainerID, removeMapHighlights]);

       const togglePhoneAccess =  useCallback((phone) => {
            if(phone){
                if(showInfo){
                    phone.tabIndex = -1      
                }else{
                    phone.tabIndex = 0   
                }
            }
       }, [showInfo])

    const toggleInfo = useCallback( e => {

        let phoneLink = document.querySelector(`#${location.ContainerID} a`)
        togglePhoneAccess(phoneLink)
       
       if (showInfo) {  
            closeLocation(e);
            return;
        }
        
        let actives = document.querySelectorAll(`article.active button:not(#${location.ContainerID}_btn)`);
        if(actives){
            for (let i = 0; i < actives.length; ++i) {
                actives[i].click();
            };
        } 

        setShowInfo(showInfo => !showInfo);
        highlightMapFrmLocation(e, location.ContainerID.substring(0, 2), 'open')
        e.stopPropagation();
        document.addEventListener("click", closeLocation);
    }, [location.ContainerID, closeLocation, showInfo, togglePhoneAccess, highlightMapFrmLocation] )



    return(
        <article id={`${location.ContainerID}`} className={`${styles.locationTab} ${showInfo ? `${styles.active} active` : ''}  `} >
            <header>
                <button id={`${location.ContainerID}_btn`} tabIndex='0' onFocus={highlightMapFrmLocation} onMouseEnter={highlightMapFrmLocation} onBlur={removeMapHighlights} onMouseLeave={removeMapHighlights} onClick={toggleInfo} aria-controls={`${location.ContainerID}-content`} aria-expanded={showInfo}>
                    <section>
                        <span className={styles.locationHeaderIcon}>
                            {location.mainOffice ? 
                                <Icon icon="mdi:office-building-marker" className={`${styles.mainOffice__icon} ${styles.icon}`} inline={true} /> : 
                                <Icon className={`${styles.mapPin__icon} ${styles.icon}`} icon="mdi:map-marker" inline={true} /> }
                        </span>
                        {location.Title}
                    </section>
                    <Icon className={`${styles.dropdownArrow__icon} ${styles.icon}`} icon="eva:arrow-ios-downward-fill" inline={true} />
                </button>
            </header>
            <section id={`${location.ContainerID}-content`} className={`collapsible ${showInfo ? ('show') : ''}`} >
                <div className={styles.locationTab__trim}></div>
                <address>
                    <p>{location.Address1}</p>
                    <p>{location.Address2}</p>
                </address>
                {location.Phone ? 
                    <a tabIndex='-1' 
                        className={styles.phone__link} 
                        href={`tel:+${location.Phone}`}>
                            <Icon className={styles.phone__icon} 
                                icon="clarity:phone-handset-solid" 
                                inline={true} />{location.Phone}
                    </a>
                    : ''}
                
            </section>
        </article>
    )
}

export default LocationTab 